import React, { useState, useEffect } from "react";
import {
  getIstoricSalariiPontajeUser,
  getIstoricAnualePontajeUser as getIstoricAnualePontajeUserService
} from "../backend/PontajeService";
import IstoricSalariiPontajTehnicianItem from "./IstoricSalariiPontajTehnicianItem";
import IstoricAnualPontajTehnicianItem from "./IstoricAnualPontajTehnicianItem";

const IstoricSalariiPontajTehnician = ({ user }) => {
  const [istoricSalarii, setIstoricSalarii] = useState([]);
  const [istoricAnualePontaje, setIstoricAnualePontaje] = useState([]);

  const getIstoricSalariiUser = async () => {
    try {
      const result = await getIstoricSalariiPontajeUser(user);
      setIstoricSalarii(result);
    } catch (err) {
      console.error(err);
    }
  };

  const getIstoricAnualePontajeUser = async () => {
    try {
      const result = await getIstoricAnualePontajeUserService(user);
      setIstoricAnualePontaje(result);
    } catch (err) {
      console.error(err);
    }
  };

  const getIstoricAnualPontajByYear = (year) => {
    return istoricAnualePontaje.find((item) => {
      const date = new Date(item.date);
      return date.getFullYear() === year;
    });
  };

  useEffect(() => {
    if (user) {
      getIstoricSalariiUser();
      getIstoricAnualePontajeUser();
    }
  }, [user]);

  return (
    <div className="tab_istoric_salarii_tehnician">
      {istoricAnualePontaje &&
        istoricAnualePontaje.length > 0 &&
        <IstoricAnualPontajTehnicianItem
          key={100}
          istoricAnualPontaj={istoricAnualePontaje[0]}>

        </IstoricAnualPontajTehnicianItem>
      }
      {istoricSalarii.map((istoricSalariu, index) => (
        <React.Fragment key={index}>
          <IstoricSalariiPontajTehnicianItem
            key={index}
            istoricSalariu={istoricSalariu}
          />
          {
            new Date(istoricSalariu.date).getMonth() === 0 && 
            getIstoricAnualPontajByYear(new Date(istoricSalariu.date).getFullYear()-1) &&
            <IstoricAnualPontajTehnicianItem
              istoricAnualPontaj={getIstoricAnualPontajByYear(new Date(istoricSalariu.date).getFullYear()-1)}/>
          }
        </React.Fragment>
      ))}
    </div>
  );
};

export default IstoricSalariiPontajTehnician;
